import * as PropTypes from 'prop-types';
import * as React from 'react';
import UrlHelpers from '../../shared/url_helpers';
import ModalUpsells from '../../listings/cart/modal_upsells';
import ModalProductSummary from './modal_product_summary';
import { HashUtil } from '@reverbdotcom/discovery-ui';

class SuccessModal extends React.Component {
  cartItemForProductId(productId) {
    if (!this.props.cart) { return null; }

    return this.props.cart.cartItemForProductId(productId);
  }

  get directCheckoutCartCount() {
    return HashUtil.getSafely(
      this.props,
      'cart.paymentMethodGroups.direct_checkout.count',
      0,
    );
  }

  renderProducts() {
    return this.props.productIds.map((productId, i) => {
      // only show the actions on the last item row
      const isLast = i === this.props.productIds.length - 1;
      return (
        <div
          key={productId}
        >
          <ModalProductSummary
            cartItem={this.cartItemForProductId(productId)}
            zeroPercentAffirmFinancing={this.props.zeroPercentAffirmFinancing}
            directCheckoutCartCount={this.directCheckoutCartCount}
            showActions={isLast}
          />
        </div>
      );
    });
  }

  renderUpsells() {
    return (
      <div className="bdt-1 bd--offwhite scaling-padding-2">
        <ModalUpsells
          listingId={this.props.productIds[0]}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        <h2 className="align-center size-140 mobile-size-120 color-green icon-l-check scaling-ptb-2 scaling-plr-5 bdb-1 bd--offwhite">
          {this.props.message}
        </h2>

        <div>
          {this.renderProducts()}
          {this.renderUpsells()}
        </div>
      </div>
    );
  }
}

SuccessModal.propTypes = {
  productIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  cart: PropTypes.object,
  message: PropTypes.string,
  zeroPercentAffirmFinancing: PropTypes.bool,
};

SuccessModal.defaultProps = {
  zeroPercentAffirmFinancing: false,
};

export default SuccessModal;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/success_modal.jsx